import { Label } from "@/components/ui/label";
import { useT } from "@/lib/i18n";

export const CLIENT_TYPE_OPTIONS = [
  { value: "prospect", labelKey: "client_type.prospect" },
  { value: "trainee", labelKey: "client_type.trainee" },
  { value: "coachee", labelKey: "client_type.coachee" },
];

/**
 * Backwards-compat: legacy callers expect a simple {prospect: "Prospect", ...}
 * map. Components that need the translated label should use `useClientTypeLabel`
 * (a hook) instead.
 */
export const CLIENT_TYPE_LABEL = {
  prospect: "Prospect",
  trainee: "Trainee",
  coachee: "Coachee",
};

export function useClientTypeLabel() {
  const { t } = useT();
  return (v) => t(`client_type.${v || "prospect"}`);
}

export default function ClientTypeField({
  value,
  onChange,
  testid = "client-type-input",
  label,
}) {
  const { t } = useT();
  const current = value || "prospect";
  return (
    <div className="space-y-2">
      <Label className="text-xs font-bold uppercase tracking-[0.2em] text-[#1A1D1A]">
        {label ?? t("coach_users.col.type")}
      </Label>
      <div className="grid grid-cols-3 gap-2" data-testid={testid}>
        {CLIENT_TYPE_OPTIONS.map(({ value: v, labelKey }) => {
          const active = current === v;
          return (
            <button
              key={v}
              type="button"
              onClick={() => onChange(v)}
              data-testid={`${testid}-${v}`}
              className={`h-11 rounded-lg border text-sm font-medium transition-colors ${
                active
                  ? "bg-[#4A5D4E] text-white border-[#4A5D4E]"
                  : "bg-white text-[#1A1D1A] border-[#E5E2DC] hover:bg-[#F2F0EA]"
              }`}
            >
              {t(labelKey)}
            </button>
          );
        })}
      </div>
    </div>
  );
}
